import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.SelectUsageBaseTaskModal.title',
    defaultMessage: 'Select Base Usage Task',
  },
  confirm: {
    id: 'containers.OrderPage.components.SelectUsageBaseTaskModal.confirm',
    defaultMessage: 'Extend This Task',
  },
  noSupplier: {
    id: 'containers.OrderPage.components.SelectUsageBaseTaskModal.noSupplier',
    defaultMessage: 'No supplier set',
  },
  notSet: {
    id: 'containers.OrderPage.components.SelectUsageBaseTaskModal.notSet',
    defaultMessage: 'Not Set',
  },
  started: {
    id: 'containers.OrderPage.components.SelectUsageBaseTaskModal.started',
    defaultMessage: 'Started',
  },
  media: {
    id: 'containers.OrderPage.components.SelectUsageBaseTaskModal.media',
    defaultMessage: 'Media',
  },
  territoryMarket: {
    id: 'containers.OrderPage.components.SelectUsageBaseTaskModal.territoryMarket',
    defaultMessage: 'Territory/Market',
  },
  airingTime: {
    id: 'containers.OrderPage.components.SelectUsageBaseTaskModal.airingTime',
    defaultMessage: 'Airing Time',
  },
})
